import { render, staticRenderFns } from "./vs_csm_trn_descmodal2.vue?vue&type=template&id=722600ef"
import script from "./vs_csm_trn_descmodal2.vue?vue&type=script&lang=js"
export * from "./vs_csm_trn_descmodal2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports